import { Layout } from 'antd';
import styled from 'styled-components';
import { motion } from 'motion/react';
import BlButton from '@/assets/game-chess/Button.png';

export const Wrapper = styled(Layout)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #111111;
  @property --angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }

  @property --angle1 {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }

  @property --angle1 {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }
  .user-bg {
    padding: 1.5px;
    .user-bg-after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 50%;
      left: 50%;
      translate: -50% -50%;
      z-index: 1;

      background: linear-gradient(135.72deg, rgba(255, 255, 255, 0.1) 26.13%, rgba(247, 247, 247, 0) 76.75%);
    }
    &.active {
      .user-bg-after {
        background: linear-gradient(var(--angle1), #eada85 0%, #ffffff 100%);
        animation: 3s spin1 linear infinite;
      }
    }
  }

  .playground {
    width: 100%;
    position: relative;
    padding: 5px;
    .playground-main {
      background: radial-gradient(58.81% 117.62% at 50% 50%, #2f2f3a 0%, #171719 100%);
    }
    .playground-after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 50%;
      left: 50%;
      translate: -50% -50%;
      background: linear-gradient(var(--angle), #d5ba8f 0%, #e0c495 49%, #756346 51%, #c4ab82 100%);

      z-index: 1;
      animation: 6s spin linear infinite;
    }
  }
  @keyframes spin {
    from {
      --angle: 0deg;
    }
    to {
      --angle: 360deg;
    }
  }
  @keyframes spin1 {
    from {
      --angle1: 0deg;
    }
    to {
      --angle1: 360deg;
    }
  }

  .balance-button {
    background: url(${BlButton});
    background-size: 100% 100%;
    width: 626px;
    height: 80px;
  }
`;

export const TextWrapper = styled(motion.div)`
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
`;
